import { DateRange } from '@griply/types';
import { format, isSameYear } from 'date-fns';

// Compact "start - end" label for a closed date range (both dates always
// present). Shows the year only when the range spans two calendar years.
// Distinct from getStartTillEndLabel, which handles open-ended task schedules
// (no-start / no-deadline fallbacks + same-month collapsing).
export const getDateRangeLabel = ({ startDate, endDate }: DateRange): string =>
  isSameYear(startDate, endDate)
    ? `${format(startDate, 'MMM d')} - ${format(endDate, 'MMM d')}`
    : `${format(startDate, 'MMM d, yy')} - ${format(endDate, 'MMM d, yy')}`;
